const API_URL = 'https://my-web-admin-be.vercel.app/api';

/**
 * Fetch active live projects from the portfolio backend.
 * No auth token is needed - the endpoint is public for active projects.
 */
export const fetchLiveProjects = async () => {
    try {
        console.log('Fetching live projects from portfolio API...');
        const response = await fetch(`${API_URL}/projects`);

        if (!response.ok) {
            throw new Error(`Portfolio API error: ${response.status}`);
        }

        const payload = await response.json();

        if (!payload.success || !payload.data?.projects) {
            throw new Error('Invalid API response shape');
        }

        const projects = payload.data.projects;

        console.log(`Fetched ${projects.length} projects from portfolio API`);
        return projects;
    } catch (error) {
        console.error('Error fetching portfolio live projects:', error);
        throw error;
    }
};

/**
 * Transform a portfolio API project to the ProjectCard prop shape.
 * Only maps live (non-github) projects.
 */
export const transformApiProject = (project) => {
    const isGithubLink = project.projectLink?.includes('github.com');
    return {
        title: project.title,
        description: project.description,
        tech: [],
        category: project.projectCategory,
        projectCategory: project.projectCategory,
        githubUrl: isGithubLink ? project.projectLink : null,
        homepage: !isGithubLink ? project.projectLink : null,
        thumbnail: project.thumbnail || project.thumbnailUrl || project.image || project.imageUrl || null,
        isLive: false,
        liveUrl: !isGithubLink ? project.projectLink : null,
    };
};
